import { FC } from 'react';
import cx from 'classnames/bind';

import Smile from '@/assets/smile.svg';

import styles from './Mode.module.scss';

const cn = cx.bind(styles);

const Mode: FC = () => {
  const text = 'Без баллов  •  Без баллов  • ';

  return (
    <div className={cn('container')}>
      <div className={cn('wrapper')}>
        <div className={cn('wrapper-img')}>
          <img className={cn('img')} src={Smile} alt="Смайл" />
        </div>
        <div className={cn('text')}>
          {[...text].map((symbol, index) => (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={cn('symbol')}
              style={{ transform: `rotate(${index * 12}deg)` }}
            >
              {symbol}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mode;
